"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _indexBy = _interopRequireDefault(require("transmute/indexBy"));

var _get = _interopRequireDefault(require("transmute/get"));

var _formatReferences = require("reference-resolvers/lib/formatReferences");

var _pipe = _interopRequireDefault(require("transmute/pipe"));

var formatTeams = (0, _pipe.default)((0, _formatReferences.formatToReferencesList)({
  getId: (0, _get.default)('id'),
  getLabel: (0, _get.default)('name'),
  referencedObject: function referencedObject(value) {
    return (0, _immutable.Map)(value).update('userIds', _immutable.Set);
  }
}), (0, _indexBy.default)((0, _get.default)('id')));
var _default = formatTeams;
exports.default = _default;
module.exports = exports.default;